import React, { useEffect, useContext } from "react";
import userContext from "../../context/users/UserContext";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { breadCrumbItems } from "./Helper";
import GatewaysTab from "./GatewaysTab";
import { useState } from "react";
import { getGatewayHealth, getGatewayHeartbeats, getGatewayStrip } from "../../service/GatewayHealthService";

const GatewayDashboard = () => {
  const { roles, loadByUsername, authenticated } = useContext(userContext);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
      return;
    }
  }, [authenticated]);

  return (
    <>
      {roles?.length > 0 && (
        <div className="main-container-body">
          <div className="breadCrumb" style={{ height: 32 }}>
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              boxSizing: "border-box",
              height: "calc(100% - 32px)",
            }}
          >
            <GatewaysTab />
          </div>
        </div>
      )}
    </>
  );
};

export default GatewayDashboard;
